<template>
  <!--  合同详情审批  -->
  <el-container class="audit-style">
    <el-aside width="180px" class="aside-left">
      <div class="page-input">
        <el-input
          type="number"
          v-model="gotoPage"
          size="small"
          placeholder="输入页码"
        >
          <el-button
            @click="handleContractPageClick(gotoPage)"
            slot="append"
            class="btn"
            >Go!</el-button
          >
        </el-input>
      </div>
      <p class="nav-tab">
        <span
          @click="navTab = 1"
          :class="navTab === 1 ? 'active' : ''"
          class="nav-item"
          >状态</span
        >
        <span
          @click="navTab = 2"
          :class="navTab === 2 ? 'active' : ''"
          class="nav-item"
          >预览</span
        >
      </p>
      <template v-if="navTab === 1">
        <div class="sec-content" :style="{ height: listHeight + 'px' }">
          <div class="nav-item">
            <label>文件名称</label>
            <p class="font-ellipsis" :title="detailInfo.contractName">
              {{ detailInfo.contractName }}
            </p>
          </div>
          <div class="nav-item">
            <label>文件编号</label>
            <p class="font-ellipsis" :title="detailInfo.applyNo">
              {{ detailInfo.applyNo }}
            </p>
            <label>文件来源</label>
            <p class="font-ellipsis" :title="detailInfo.ebqUserName">
              名称：{{ detailInfo.ebqUserName }}
            </p>
          </div>
          <div class="nav-item"></div>
          <template v-for="(item, index) in detailInfo.signInfos">
            <div class="nav-item" :key="index">
              <label
                >签署方{{ index + 1 }}
                <span v-if="item.signStatus == 1" class="bar-status status-blue"
                  >已签署</span
                >
                <span
                  v-else-if="item.signStatus == 2"
                  class="bar-status status-red"
                  >拒签</span
                >
                <span v-else="" class="bar-status status-orange">未签署</span>
              </label>
              <p>
                名称：{{ item.fullName }} <br />
                证件号：<br />{{ item.identityCardMask }}
              </p>
            </div>
          </template>
        </div>
      </template>
      <template v-if="navTab === 2">
        <div class="list-pages" :style="{ height: listHeight + 'px' }">
          <template v-for="i in convertInfo.items">
            <div
              @click="currentData = i"
              :class="currentData === i ? 'active' : ''"
              :key="i"
            >
              <img
                v-if="fileInfo.sign"
                :src="
                  ApiMethods.FileOperController.convertDetail_url(
                    fileInfo.sign,
                    fileInfo.ts,
                    fileInfo.fileType,
                    'png',
                    fileInfo.targetId,
                    i,
                    convertInfo.docHash || ''
                  )
                "
              />
              <span class="p-index">{{ i }}</span>
            </div>
          </template>
        </div>
      </template>
    </el-aside>

    <el-main
      ref="contrBody"
      v-loading="contractLoading"
      class="main-box"
      :style="{ height: mainHeight + 'px' }"
    >
      <div
        ref="contrScro"
        class="contr-pages-scro"
        v-show="convertInfo.items > 0"
      >
        <p class="con-pageindex">{{ currentData }}/{{ convertInfo.items }}</p>
        <img
          v-if="fileInfo.sign && convertInfo && convertInfo.items"
          :src="
            ApiMethods.FileOperController.convertDetail_url(
              fileInfo.sign || '',
              fileInfo.ts || '',
              fileInfo.fileType || '',
              'png',
              fileInfo.targetId || '',
              currentData || '',
              convertInfo.docHash || ''
            )
          "
          @loadstart="contractLoading = true"
          @load="contractLoading = false"
        />
        <div
          v-if="currentData > 1"
          @click="currentData == Math.max(--currentData, 1)"
          class="pre"
        >
          <i class="el-icon-arrow-left"></i>
        </div>
        <div
          v-if="convertInfo.items > currentData"
          @click="currentData == Math.max(++currentData, convertInfo.items)"
          class="next"
          :style="{ right: nextLeft }"
        >
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </el-main>
    <el-aside width="250px" class="aside-right" :class="'approve-aside'">
      <!--合同更多的详情信息按钮-->
      <template>
        <div class="bottom_textarea" v-if="!isInDingTalk">
          <span>审批意见：</span>
          <el-input
            type="textarea"
            rows="5"
            resize="none"
            :autofocus="true"
            size="small"
            :maxlength="100"
            placeholder="请输入审批意见"
            v-model="refuseModel.reason"
          />
        </div>
        <p>
          <el-button @click="showInfo" size="small" class="btn"
            >审批详情</el-button
          >
        </p>
        <template v-if="!isInDingTalk">
          <p>
            <el-button @click="clickHanldeAuditRefuse(1)" size="small" class="btn"
              >同意</el-button
            >
          </p>
          <p>
            <el-button @click="clickHanldeAuditRefuse(2)" size="small" class="btn"
              >拒绝</el-button
            >
          </p>
        </template>
        <template v-if="isInDingTalk">
          <p>
            <el-button type="primary" size="small" class="btn" :loading="approLoading" @click="examineHandle()"
              >审批</el-button
            >
          </p>
        </template>
      </template>
    </el-aside>

    <!-- 审核详情 Dialog -->
    <el-dialog
      :visible.sync="dialogAuditDetailVisible"
      title="审批详情"
      width="800px"
      class="apprave-info"
    >
      <el-row>
        <el-col :span="24">
          <template  v-if="!isInDingTalk">
            <audit-detail
              v-if="
                auditDetailInfo &&
                  Object.keys(auditDetailInfo).length &&
                  (auditDetailInfo.fileFlow.length ||
                    auditDetailInfo.sealFlow.length)
              "
              :auditor="auditDetailInfo"
            ></audit-detail>
            <el-empty v-else description="暂无数据"></el-empty>
          </template>
          <ding-audit-detail v-if="isInDingTalk" :auditor="auditDetailInfo" :applyInfo="detailInfo"></ding-audit-detail>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 拒绝原因 Dialog -->
    <el-dialog
      :visible.sync="dialogAuditRefuseVisible"
      title="拒绝原因"
      width="500px"
    >
      <el-row>
        <el-col :span="24">
          <div style="position: relative">
            <el-input
              ref="textareaReason"
              type="textarea"
              v-model="refuseModel.reason"
              rows="5"
              resize="none"
              :autofocus="true"
              size="small"
              :maxlength="100"
              placeholder="请输入拒绝原因,100字以内"
              @blur="handleBlur()"
            />
            <span style="position:absolute;bottom: 10px;right: 10px;color: red;"
              >{{ refuseModel.wordNumber }}/100</span
            >
          </div>
        </el-col>
        <el-col :span="24" style="height: 24px">
          <p v-if="refuseModel.errorMessage" style="color: red;">
            {{ refuseModel.errorMessage }}
          </p>
        </el-col>
      </el-row>
      <p slot="footer" class="dialog-footer">
        <el-button
          @click="dialogAuditRefuseVisible = false"
          size="small"
          class="btn"
          >取消</el-button
        >
        <el-button
          @click="clickHandleRefuseSubmit()"
          type="danger"
          size="small"
          class="btn"
          >提交</el-button
        >
      </p>
    </el-dialog>
  </el-container>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import AuditDetail from "../../components/auditDetail/new.vue";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { isInDingTalk } from '@/assets/js/utils/ding-env';
import dingAuditDetail from "@/components/auditDetail/dingNew.vue";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";

export default {
  components: {
    AuditDetail,
    dingAuditDetail
  },
  data() {
    return {
      DINGSDK: null,
      isInDingTalk,
      // 审批详情 Dialog
      dialogAuditDetailVisible: false,
      // 审批拒绝 Dialog
      dialogAuditRefuseVisible: false,
      approLoading:false, // 审批按钮Loading（钉钉）
      refuseModel: {
        reason: "",
        errorMessage: "",
        wordNumber: 0,
        flowStatus: '',
      },
      auditDetailInfo: {},

      ApiMethods: ApiMethods,

      navTab: 1,
      listHeight: "787",
      mainHeight: "1170",
      nextLeft: "0px",
      gotoPage: null,
      currentData: 1,

      viewInfo: {},
      detailInfo: {},
      fileInfo: {},
      convertInfo: {},
      contractLoading: true
    };
  },
  async created() {
    this.DINGSDK = await this.$DingSDKPromise();
  },
  mounted() {
    this.fetchData();

    let { query } = this.$route;
    this.listHeight = document.body.clientHeight - 165;
    this.mainHeight = document.body.clientHeight - 60;
  },
  watch: {
    "refuseModel.reason": function() {
      this.handleChange();
    }
  },
  methods: {
    showInfo() {
      this.clickHanldeAuditDetail();
      this.dialogAuditDetailVisible = true;
    },
    // 审批详情按钮
    clickHanldeAuditDetail() {
      let { signNo, applyNo } = this.$route.query;
      if (!signNo && !applyNo) return false;
      let params = {
        signNo: signNo ? signNo : "",
        applyNo: applyNo ? applyNo : ""
      };
      ApiCorpMethods.CorpAuditContractController.flowInstV2(params)
        .then(res => {
          if (res.success && res.code === "0") {
            if(isInDingTalk){ this.dingtalkFlowInfo() }
            if(!isInDingTalk) this.auditDetailInfo = res.data;
          } else {
            this.auditDetailInfo = {};
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          console.log('error',error);
          this.auditDetailInfo = {};
          this.$message.error(error.description || "获取审批人列表失败");
        });
    },
    /** 钉钉审批详情 */
    dingtalkFlowInfo(){
      // 查询钉钉审批详情流程
      const { dingTalkCorpId: corpId, dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo")),
      { signNo, applyNo } = this.$route.query,
      _this = this;
      const _applyNo= applyNo ? applyNo : this.detailInfo.applyNo
      const data = { corpId, dingTalkUserId,applyNo: _applyNo }
        dingtalkApi.v2TaskList(data).then(res=>{
        if(!res.success) return isInDingTalk ? false : this.$message.error(`文件审批详情：${res.description}`)
          _this.auditDetailInfo = {
          fileFlow:[res.data],
          sealFlow:[]
        }
        })
    },
    /** 跳转钉钉oa审批 */
    examineHandle(){
      const { dingTalkCorpId: corpId, dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo")),
      { signNo, applyNo } = this.$route.query,
      _this = this;
      const _applyNo= applyNo ? applyNo : this.detailInfo.applyNo
      const param = { corpId, dingTalkUserId, applyNo: _applyNo }
      dingtalkApi.workflowContract(param).then(res=>{
        if(!res.success) return _this.$message.error(res.description)
        _this.approLoading=true
        // location.href= res.data
        /** 钉钉弹窗逻辑 */
        this.DINGSDK && this.DINGSDK.biz.util.openSlidePanel({
            url: res.data, //打开侧边栏的url
            title: '审批', //侧边栏顶部标题
            onSuccess: function (result) { },
            onFail: function () { }
          }).catch((err) => { console.log('跳转钉钉oa审批-catch_err：', err); })
      }).finally(() => { _this.approLoading=false })
    },
    // 审批通过
    clickHanldeAuditPass() {
      this.$confirm(
        `
					<h5>是否同意审批</h5>
					<p style="color:#F56C6C">
						<span style="color:#666666">您还要继续吗?</span>
					</p>
				`,
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          this.executeAudit(true);
        })
        .catch(() => {});
    },
    // 审批拒绝
    clickHanldeAuditRefuse(type) {
      this.refuseModel.flowStatus = type;
      if (type === 2 && this.refuseModel.reason === '') {
        return this.$message.error("请输入审批意见")
      }
      this.$confirm(`是否${['', '同意', '拒绝'][type]}审批？`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let str = type === 1
          this.executeAudit(str)
        })
        .catch(() => { });
      // this.refuseModel.reason = "";
      // this.refuseModel.errorMessage = "";
      // this.dialogAuditRefuseVisible = true;
      // this.$nextTick(() => {
      //   if (this.$refs.textareaReason) {
      //     this.$refs.textareaReason.focus();
      //   }
      // });
    },
    // 审批拒绝 提交拒绝原因
    clickHandleRefuseSubmit() {
      this.handleBlur();
      if (!this.refuseModel.errorMessage) {
        this.executeAudit(false);
      }
    },
    // 拒绝原因改变事件
    handleChange() {
      this.refuseModel.wordNumber = this.refuseModel.reason.length;
    },
    // 拒绝原因失去焦点事件
    handleBlur() {
      let v = this.refuseModel.reason;
      if (v) {
        if (v.length > 100) {
          this.refuseModel.errorMessage = "拒绝原因不能超过100个字";
        } else {
          this.refuseModel.errorMessage = "";
        }
      } else {
        this.refuseModel.errorMessage = "请输入拒绝原因";
      }
    },
    // 提交审核结果
    executeAudit(v) {
      let params = {};
      let { query } = this.$route;
      params.approveId = query.approveId;
      if (v) {
        params.flowStatus = 1;
      } else {
        params.flowStatus = 2;
      }
      params.reason = this.refuseModel.reason;
      // console.info(params)
      ApiCorpMethods.CorpAuditContractController.approveFlow(params)
        .then(res => {
          if (res.code === "0") {
            if (window.opener) {
              window.opener.location.reload();
            }
            window.close();
          } else {
            this.$message.error(res.description || "审批驳回");
          }
        })
        .catch(error => {
          this.$message.error(error.description || "审批驳回");
        });
    },

    // 输入input合同跳页
    handleContractPageClick(page) {
      if (!page) return this.$message.warning("请输入正确的页数");
      if (page < 1 || page > this.convertInfo.items)
        return this.$message.warning("请输入正确的页数");
      this.currentData = parseFloat(page);
    },

    loadData: function() {
      var _this = this;
      ApiMethods.ApplySignController.info(_this.viewInfo).then(result => {
        if (!result.success) {
          return _this.$message.error(result.description || "初始化数据失败2");
        }
        _this.detailInfo = result.data;
        _this.fileInfo = result.data.fileInfo;

        // 极简模式
        if (
          (_this.detailInfo && _this.detailInfo.ifHideBottom == 1) ||
          (_this.detailInfo && _this.detailInfo.hideSignAllBtnFlag == 1)
        ) {
          document.querySelector("header.el-header").style.display = "none";
          _this.mainHeight = _this.mainHeight + 60;
        } else {
          document.querySelector("header.el-header").style.display = "block";
        }
        /*{
          "applyNo":"","contractName":"","signStatus":1,"createTime":"","signTime":"","createType":1,"ebqUserName":"陈辉",
          "signInfos":[{"signNo":"","fullName":"1222","identityCardMask":"","identityType":1,"mobileMask":"","signStatus":1,"signTime":"","identityLevel":2}],
          "fileInfo":{"targetId":"","fileType":3,"ts":1533039428005,"sign":""}
          }*/
        ApiMethods.FileOperController.convertInfoNoFile(
          result.data.fileInfo
        ).then(result => {
          //"data":{"stype":"isimgs","items":13,"docHash":"Zcd7luVpZPT31aXvBIwiUNVt764UwL0dpphB0-WanJWRBQuowoY_LO2hRnSDPapTavj-LG-Z6t0CXv772aj2-Q"}
          if (!result.success) {
            return _this.$message.error(result.description || "文件转换错误");
          }
          _this.convertInfo = result.data;
          window.setTimeout(function() {
            const vi = _this.$refs.contrScro.offsetWidth;
            const vm = _this.$refs.contrBody.$el.offsetWidth;
            if (vi < vm) {
              _this.nextLeft = (vm - vi) / 2 + 153 + "px";
            } else {
              _this.nextLeft = "156px";
            }
            //contrBody
          }, 1000);
        });
      });
    },
    fetchData: function() {
      if (this.$route.query.ts && this.$route.query.sign) {
        this.viewInfo = this.$route.query;
        this.loadData();
      } else {
        //没有签名参数
        var param = {
          signNo: this.$route.query.signNo,
          applyNo: this.$route.query.applyNo
        };
        ApiMethods.UserApplySignController.viewUrl(param).then(result => {
          //{"applyNo":"","ts":,"sign":"","signNo":""}
          if (!result.success) {
            return this.$message.error(result.description || "初始化数据失败1");
          }
          this.viewInfo = result.data;
          this.loadData();
        });
      }
    }
  },
  head: {
    title: "文件审批"
  },
  name: "audit",
  layout: "fullpage"
};
</script>

<style lang="less" scoped>
.apprave-info /deep/ .el-dialog__body {
  height: 65vh;
  overflow-y: scroll;
  background-color: #e7e7e7;
}
.demo-dynamic {
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.sdetails-dialog {
  .sdetails {
    height: 450px;
    overflow-x: hidden;
    margin: -20px -20px -10px;
    padding: 20px 20px 10px;

    .sdetails-item {
      padding: 20px 0;
      border-bottom: 1px solid #e7e7e7;
    }

    b {
      color: #009899;
    }

    h5 {
      margin: 0;
      color: #009899;
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 6px;
    }

    p {
      color: #333;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
      word-break: break-all;
    }
  }
}

.aside-right {
  padding: 20px 20px 0px 20px;

  &.approve-aside {
    padding: 0;
    padding-top: 20px;
    text-align: center;

    .btn {
      width: 80%;
      margin: 0;
      margin-bottom: 10px;
    }
  }
  .bottom_textarea {
    padding: 20px 10px;
  }
  .btn {
    width: 100%;
    margin-bottom: 20px;
  }
}
.main-box {
  display: table-cell;
  padding: 0;
  background: #eee;
  text-align: center;
  height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .con-pageindex {
    position: absolute;
    top: 0;
    width: 100%;
    padding: 16px 0;
    z-index: 1000;
  }

  .contr-pages-scro {
    display: inline-block;
    position: relative;
    background: #ffffff;

    .next {
      position: fixed;
      top: 40%;
      width: 40px;
      padding: 20px 0;
      background: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      z-index: 1020;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      i {
        color: #ffffff;
        font-size: 40px;
      }
    }
    .pre {
      position: fixed;
      top: 40%;
      width: 40px;
      padding: 20px 0;
      background: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      z-index: 1020;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      i {
        color: #ffffff;
        font-size: 40px;
      }
    }
  }
}

.aside-left {
  height: 100%;
  overflow: hidden;

  .list-pages {
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 20px;
    background: #fff;
    color: #323232;

    div.active {
      img {
        border-color: #ec1c1c;
      }
    }

    div {
      position: relative;
      box-sizing: border-box;
      margin: 0 30px 20px 30px;
      cursor: pointer;

      .p-index {
        position: absolute;
        box-sizing: border-box;
        bottom: 10px;
        right: 0;
        display: block;
        width: 20px;
        height: 20px;
        color: #fff;
        background-color: #ec1c1c;
        text-align: center;
      }

      img {
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 10px;
        border: 2px solid #e3e3e3;
      }
    }
  }
}

.sec-content {
  overflow-y: auto;
  overflow-x: hidden;

  p {
    color: #bcbcbc;
    margin-bottom: 16px;
  }

  label {
    font-size: 14px;
  }

  .nav-item {
    width: 180px;
    padding: 16px 15px 0 15px;
    border-bottom: 1px solid #ebebeb;
    font-size: 12px;
    box-sizing: border-box;
  }
}

.nav-tab {
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  border-bottom: 1px solid #e4e4e4;
  text-align: left;

  .nav-item {
    display: inline-block;
    box-sizing: border-box;
    padding: 6px;
    width: 72px;
    background: #fff;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border: 1px solid #e4e4e4;
    border-bottom: 0;
    font-size: 12px;
    cursor: pointer;
    text-align: center;
    color: #666666;
  }
  .nav-item.active {
    color: #fff;
    background-color: #ec1c1f;
    border-color: #ec1c1f;
  }
}

.audit-style {
  margin: -20px;
  background-color: #ffffff;
  .page-input {
    width: 150px;
    margin: 10px 15px 20px 15px;
    position: relative;

    .btn {
      padding: 0;
      width: 50px;
      margin: 0 -20px;
    }

    .input {
      display: inline-block;
      box-sizing: border-box;
      width: 100px;
      height: 34px;
      font-size: 13px;
      padding: 0 10px;
      line-height: 1.42857143;
      color: #999999;
      background-color: #ffffff;
      background-image: none;
      border: 1px solid #cccccc;
      border-radius: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/applySign/audit.vue